import { lazyWithPreload } from "@utils/lazyWithPreload";
import { Suspense } from "react";

const LazyAppContentInner = lazyWithPreload(() => import("./AppContentInner"));

// Start fetching the AppContentInner chunk immediately — avoids a waterfall where the
// chunk download only begins after MemberSettingsLoader resolves.
LazyAppContentInner.preload();

/**
 * Shell that lazy-loads desktop blocker gate + router.
 * Keeps desktop-blocker, useServerConfig, useServerInfo, and AppRouter out of the main bundle.
 */
const AppContent = () => {
  return (
    <Suspense fallback={null}>
      <LazyAppContentInner />
    </Suspense>
  );
};

export default AppContent;
